import React from 'react';
import { ReactComponent as WarningIcon } from '../assets/icons/warning.svg';
import { ReactComponent as SuccessIcon } from '../assets/icons/success.svg';

// Inline status glyph for summary log lines. Backend log entries carry an
// optional `icon: 'warning' | 'success'` field (see main.js DjLibrarySync)
// instead of baking an emoji into the msg string.
const ICONS = { warning: WarningIcon, success: SuccessIcon };

const LogStatusIcon = ({ icon }) => {
    const Icon = ICONS[icon];
    return Icon ? <Icon className={`log-status-icon log-status-icon--${icon}`} /> : null;
};

export default LogStatusIcon;
